export default __webpack_public_path__ + "static/media/order4.a7aa87d7.svg";